import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp, DollarSign, Hash } from 'lucide-react';

function formatCurrency(value) {
  if (value == null) return '$0';
  return '$' + Number(value).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export default function MiniForecastCard({ widgetData }) {
  const forecast = widgetData?.forecast;

  if (!forecast) {
    return <div className="mini-chart-empty">No forecast data</div>;
  }

  return (
    <div className="mini-chart-container">
      <div className="mini-forecast-stats">
        <div className="mini-forecast-stat">
          <Hash size={16} />
          <div>
            <div className="mini-forecast-value">{forecast.deal_count || 0}</div>
            <div className="mini-forecast-label">Open Deals</div>
          </div>
        </div>
        <div className="mini-forecast-stat">
          <DollarSign size={16} />
          <div>
            <div className="mini-forecast-value">{formatCurrency(forecast.total_pipeline)}</div>
            <div className="mini-forecast-label">Pipeline</div>
          </div>
        </div>
        <div className="mini-forecast-stat">
          <TrendingUp size={16} />
          <div>
            <div className="mini-forecast-value">{formatCurrency(forecast.weighted_forecast)}</div>
            <div className="mini-forecast-label">Weighted</div>
          </div>
        </div>
      </div>
      <Link to="/reports?type=forecast" className="mini-chart-link">View Full Report</Link>
    </div>
  );
}
